/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_Saved_SuccessInputs */

const en_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User record saved successfully`)
};

const fr_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement de l’utilisateur réussi`)
};

const de_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdatensatz erfolgreich gespeichert`)
};

const it_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Record utente salvato correttamente`)
};

const ru_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись пользователя успешно сохранена.`)
};

const es_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El registro de usuario se guardó correctamente`)
};

const zh_cn2_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户记录已成功保存`)
};

const ja_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーレコードが正常に保存されました`)
};

const hi_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता का रिकॉर्ड सफलतापूर्वक सहेज लिया गया`)
};

const pt_pt2_team_manager_user_saved_success = /** @type {(inputs: Team_Manager_User_Saved_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro do usuário salvo com sucesso`)
};

/**
* | output |
* | --- |
* | "User record saved successfully" |
*
* @param {Team_Manager_User_Saved_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_saved_success = /** @type {((inputs?: Team_Manager_User_Saved_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_Saved_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_user_saved_success(inputs)
	if (locale === "de") return de_team_manager_user_saved_success(inputs)
	if (locale === "it") return it_team_manager_user_saved_success(inputs)
	if (locale === "ru") return ru_team_manager_user_saved_success(inputs)
	if (locale === "es") return es_team_manager_user_saved_success(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_user_saved_success(inputs)
	if (locale === "ja") return ja_team_manager_user_saved_success(inputs)
	if (locale === "hi") return hi_team_manager_user_saved_success(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_user_saved_success(inputs)
	return en_team_manager_user_saved_success(inputs)
});